import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import checkLanguage from "./helpers/checkLanguage";
import en from "./locales/en/translation.json";
import rw from "./locales/rw/translation.json";

const preferredLanguage = checkLanguage() || "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      rw: { translation: rw },
    },
    lng: preferredLanguage,
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
